import { AppRoute } from '@/modules/drivers/types'
import * as React from 'react'
import { AlertsListPage } from './pages'
import TimetableViewControlBar from './shared/viewBars/TimetableViewControlBar'

import { TIMETABLE_ROUTES } from './routes-typed'

export const timetableRoutesMap: Record<string, string> = {
  alertsList: TIMETABLE_ROUTES.alertsList.path,
  alertsListWithDateRange: TIMETABLE_ROUTES.alertsListWithDateRange.path,
}

export const timetableRoutes: AppRoute[] = [
  {
    path: timetableRoutesMap.alertsListWithDateRange,
    exact: false,
    component: AlertsListPage,
    navigation: false,
    heightScreen: true,

    viewControlBar: () => <TimetableViewControlBar />,
  },
  {
    path: timetableRoutesMap.alertsList,
    exact: false,
    component: AlertsListPage,
    navigation: false,
    heightScreen: true,

    viewControlBar: () => <TimetableViewControlBar />,
  },
]
